const meta = {
  'analyze-alerts': 'Analyze',
  'monitor-actions': 'Actions',
  'data-model': 'Data model',
};

export default meta;
